import { render, staticRenderFns } from "./dust-form.vue?vue&type=template&id=33ea51a5&"
import script from "./dust-form.vue?vue&type=script&lang=js&"
export * from "./dust-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports